import React, { useState, useEffect } from 'react';
import { updateBounty, getDetailBounty, createBounty } from 'redux/actions/daoUI/bounty.action';
import GeneralTab from './GeneralTab';
import ChallengesTab from './ChallengesTab';
import AdditionalsTab from './AdditionalsTab';
import TeamsTab from './TeamsTab';
import SubmissionsTab from './SubmissionsTab';
import moment from 'moment';

const ALL_TABS = [
  { key: 'GENERAL', label: 'GENERAL' },
  { key: 'CHALLENGES', label: 'CHALLENGES' },
  { key: 'ADDITIONALS', label: 'ADDITIONALS' },
  { key: 'TEAMS', label: 'TEAMS' },
  { key: 'SUBMISSIONS', label: 'SUBMISSIONS' },
];

const CREATE_TABS = [
  { key: 'GENERAL', label: 'GENERAL' },
];

const BountyDetailModal = ({ open, onClose, bounty, onSubmit, daoId, onSuccess }) => {
  const [editedBounty, setEditedBounty] = useState(bounty);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedTab, setSelectedTab] = useState('GENERAL');

  useEffect(() => {
    if (bounty?.id) {
      getDetailBounty(bounty.id)()
        .then(response => {
          if (response && response?.data) {
             setEditedBounty(response?.data);
             console.log('dataaaaa', response?.data)
          }
        })
        .catch(err => {
          console.error('Error fetching bounty details:', err);
        });
    } else {
      // Khởi tạo dữ liệu mặc định cho trường hợp tạo mới
      setEditedBounty({
        // Thông tin cơ bản
        name: '',
        description: '',
        theme: '',
        type: '',
        status: 'DRAFT',
        daoId: daoId,
        
        // Thông tin hình ảnh
        banner: '',
        thumbnail: '',
        emailHeaderImage: '',
        
        // Thông tin cấu hình
        isVisible: true,
        proposalRequired: false,
        slots: '',
        registerLimited: '',
        
        // Thông tin thời gian
        startDate: moment().valueOf(),
        endDate: moment().add(30, 'days').valueOf(),
        closedDate: moment().add(45, 'days').valueOf(),
        
        // Các trường mặc định khác
        reward: 0,
        challenges: [],
        teams: [],
        submissions: []
      });
    }
  }, [bounty?.id, daoId]);

  if (!open) return null;

  const handleInputChange = (field, value) => {
    if (['startDate', 'endDate', 'closedDate'].includes(field)) {
      const dateValue = moment(value, 'YYYY-MM-DD').valueOf();
      setEditedBounty(prev => ({
        ...prev,
        [field]: dateValue
      }));
      return;
    }
    
    setEditedBounty(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = () => {
    if (editedBounty.id) {
      updateBounty(editedBounty.id, editedBounty)()
        .then(() => {
          setIsEditing(false);
          alert('Cập nhật bounty thành công!');
          if (onSuccess) onSuccess();
        })
        .catch((err) => {
          console.error('Error updating bounty:', err);
          alert('Có lỗi xảy ra khi cập nhật bounty!');
        });
    } else {
      createBounty(editedBounty)()
        .then((response) => {
          if (response?.data?.id) {
            // Gọi lại API lấy chi tiết bounty sau khi tạo mới thành công
            getDetailBounty(response.data.id)()
              .then(detailResponse => {
                if (detailResponse && detailResponse?.data) {
                  setEditedBounty(detailResponse.data);
                  setIsEditing(false);
                  alert('Tạo mới bounty thành công!');
                  if (onSuccess) onSuccess();
                }
              })
              .catch(err => {
                console.error('Error fetching new bounty details:', err);
                alert('Tạo mới thành công nhưng không thể tải thông tin chi tiết!');
                if (onSuccess) onSuccess();
              });
          }
        })
        .catch((err) => {
          console.error('Error creating bounty:', err);
          alert('Có lỗi xảy ra khi tạo mới bounty!');
        });
    }
  };

  const handleSubmitAddional = (data) => {
    return updateBounty(editedBounty.id, data)()
      .then((response) => {
        setIsEditing(false);
        alert('Cập nhật thành công!');
        return response
      })
      .catch((err) => {
        console.error('Error updating bounty:', err);
        alert('Có lỗi xảy ra khi cập nhật bounty!');
        return null
      });
  };

  const renderTabContent = () => {
    if (selectedTab === 'GENERAL') {
      return (
        <GeneralTab
          editedBounty={editedBounty}
          handleInputChange={handleInputChange}
          onSave={handleSubmit}
          onCancel={() => setEditedBounty(bounty)}
          activeTab={selectedTab}
        />
      );
    }
    if (selectedTab === 'CHALLENGES') {
      return (
        <ChallengesTab
          bountyId={bounty?.id}
          activeTab={selectedTab}
        />
      );
    }
    if (selectedTab === 'ADDITIONALS')
      return (
        <AdditionalsTab
          bounty={editedBounty}
          onSubmit={handleSubmitAddional}
        />
      );
    if (selectedTab === 'TEAMS') return <TeamsTab bounty={editedBounty} bountyId={bounty?.id} activeTab={selectedTab} />;
    if (selectedTab === 'SUBMISSIONS') return <SubmissionsTab />;
    return null;
  };

  // Chọn danh sách tab dựa trên việc có id hay không
  const tabs = editedBounty?.id ? ALL_TABS : CREATE_TABS;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff', borderRadius: 4, width: '90vw', height: '90vh', maxWidth: '90vw', maxHeight: '90vh', overflowY: 'auto', padding: 0, position: 'relative', display: 'flex'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 16, right: 16, background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer', zIndex: 2
          }}
        >×</button>
        {/* Sidebar Tabs */}
        <div style={{ 
          width: 220, 
          backgroundColor: '#282f39',
          borderTopLeftRadius: '8px',
          borderBottomLeftRadius: '8px'
        }}>
          <ul style={{
            listStyleType: 'none',
            paddingLeft: 0,
            margin: 0
          }}>
            {tabs.map(tab => {
              const isActive = selectedTab === tab.key;
              return (
                <li key={tab.key} style={{ lineHeight: '54px' }}>
                  <a 
                    onClick={() => setSelectedTab(tab.key)}
                    style={{ 
                      cursor: 'pointer',
                      color: isActive ? '#1AEEC2' : '#8CA0A7',
                      textDecoration: 'none',
                      display: 'block',
                      padding: '0 24px',
                      transition: 'color 0.2s'
                    }}
                    onMouseOver={(e) => {
                      if (!isActive) e.target.style.color = '#1AEEC2';
                    }}
                    onMouseOut={(e) => {
                      if (!isActive) e.target.style.color = '#8CA0A7';
                    }}
                  >
                    {tab.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        {/* Tab Content */}
        <div style={{ flex: 1, padding: 32, minWidth: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <h2>
              General information <span>(Bounty {editedBounty?.name || ''})</span>
            </h2>
          </div>
          <div style={{ width: '100%', height: 'calc(90vh - 120px)', overflowY: 'auto' }}>
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BountyDetailModal; 